const workapi = [
    {
        id: 1,
        logo: "fas fa-download",
        title: "Download App",
        info: "Please download our app from the Apple App Store and Google Play Store. ",
    },
    {
        id: 2,
        logo: "fas fa-chalkboard-teacher",
        title: "Complete the Instruction ",
        info: "After downloading the app, please signup onto the account and complete the instruction and verify the Email to access the account.",
    },
    {
        id: 3,
        logo: "fas fa-donate",
        title: "Receive your funds",
        info: "After signing up and logging into your account, there you go! Now you can send and recieve money securely and fast using our Ground Breaking and revolutionary technology. ",
    },
];

export default workapi;